export interface AuthTokenClaims {
  participant_id: string;
  order_id: string;
  payment_intent_id: string;
  customer_profile_id: string;
  customer_ref?: string;
  authentication_id: string;
  cardholderAuthType: string;
  exp: number;
}

export function parseAuthToken(token: string): AuthTokenClaims {
  try {
    const payload = token.split(".")[1];
    const decodedPayload = atob(payload);
    return JSON.parse(decodedPayload) as AuthTokenClaims;
  } catch (cause) {
    throw new Error("checkout-customer-api: could not parse auth_token", { cause });
  }
}
